import React from "react";

export const LOBBY_REVIEW_PANEL_ANCHOR_ID = "lobby-review-panel-anchor";

const LobbyReviewPanelBridgeContext = React.createContext({
  isPendingReviewPanelActive: false,
  isPendingReviewPanelOpen: true,
  setPendingReviewPanelActive: () => {},
  openPendingReviewPanel: () => {},
  closePendingReviewPanel: () => {},
});

export function LobbyReviewPanelBridgeProvider({ children }) {
  const [isPendingReviewPanelActive, setIsPendingReviewPanelActive] = React.useState(false);
  const [isPendingReviewPanelOpen, setIsPendingReviewPanelOpen] = React.useState(true);

  const value = React.useMemo(
    () => ({
      isPendingReviewPanelActive,
      isPendingReviewPanelOpen,
      setPendingReviewPanelActive: setIsPendingReviewPanelActive,
      openPendingReviewPanel: () => setIsPendingReviewPanelOpen(true),
      closePendingReviewPanel: () => setIsPendingReviewPanelOpen(false),
    }),
    [isPendingReviewPanelActive, isPendingReviewPanelOpen]
  );

  return (
    <LobbyReviewPanelBridgeContext.Provider value={value}>
      {children}
    </LobbyReviewPanelBridgeContext.Provider>
  );
}

export function useLobbyReviewPanelBridge() {
  return React.useContext(LobbyReviewPanelBridgeContext);
}
